import React from "react";

const GuaranteedDepartureBadge = () => (
  <div className="gd-inline">
    <div className="gd-inline_icon">
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2525 2.6369C13.1139 2.36954 12.8831 2.16152 12.6028 2.05143C10.7348 1.32674 8.89966 0.635334 7.10716 0.0451776C6.92578 -0.0150592 6.72979 -0.0150592 6.54841 0.0451776C4.75779 0.633928 2.92123 1.32393 1.05373 2.04768C0.805915 2.14497 0.595799 2.31911 0.454196 2.54455C0.464977 2.54455 0.0702899 3.7769 0.00325866 6.49659C-0.0365851 9.21534 0.302321 10.031 0.291071 10.0319C0.474352 10.6296 0.817008 11.2375 1.30873 11.8563C1.85857 12.5467 2.60107 13.2597 3.49779 13.961C4.98279 15.1263 6.37216 15.8224 6.43216 15.8449C6.55587 15.9067 6.69228 15.939 6.8306 15.939C6.96892 15.939 7.10533 15.9067 7.22904 15.8449C7.28763 15.82 8.67888 15.1216 10.1629 13.9563C11.0597 13.2531 11.8036 12.5416 12.3525 11.8511C12.8793 11.1892 13.2351 10.5386 13.4076 9.90112C13.4006 9.90112 13.6495 8.90127 13.6153 6.61283C13.5903 5.28051 13.4691 3.95173 13.2525 2.6369Z" fill="url(#v3gdi-shield)"/>
        <path d="M10.7287 6.42329C9.41054 7.78032 8.05679 9.2011 6.72882 10.6036C6.62099 10.718 6.49088 10.8092 6.34651 10.8715C6.20213 10.9339 6.04654 10.966 5.88929 10.9659H5.88414C5.72689 10.9643 5.57157 10.9312 5.42725 10.8688C5.28293 10.8063 5.15253 10.7157 5.04367 10.6022C4.33304 9.86625 3.61726 9.13219 2.90617 8.41219C2.79837 8.30445 2.71339 8.17608 2.65631 8.03477C2.59922 7.89345 2.5712 7.74208 2.57391 7.58969C2.57662 7.4373 2.61002 7.28703 2.6721 7.14783C2.73418 7.00863 2.82367 6.88338 2.93523 6.77954C3.40398 6.33 4.14648 6.32813 4.59601 6.78938C5.0182 7.22188 5.44226 7.6575 5.8682 8.09625C6.92336 6.98954 7.98226 5.87438 9.01351 4.7911C9.45132 4.32985 10.1854 4.33547 10.6602 4.7911C11.1351 5.24672 11.1716 5.96813 10.7287 6.42329Z" fill="url(#v3gdi-check)"/>
        <defs>
          <linearGradient id="v3gdi-shield" x1="12.1603" y1="12.1286" x2="1.49294" y2="1.46127" gradientUnits="userSpaceOnUse">
            <stop stopColor="#13B601"/><stop offset="0.52" stopColor="#13B601"/><stop offset="1" stopColor="#CBF4B4"/>
          </linearGradient>
          <linearGradient id="v3gdi-check" x1="8.74492" y1="8.58844" x2="4.93538" y2="4.77891" gradientUnits="userSpaceOnUse">
            <stop stopColor="#CBF4B4"/><stop offset="0.57" stopColor="white"/><stop offset="1" stopColor="white"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <span className="gd-inline_text">Guaranteed Departure</span>
  </div>
);

const RouteDivider = ({ isMobile }: { isMobile?: boolean }) => (
  <div className="flight-card_divider" aria-hidden="true">
    {isMobile ? <svg viewBox="0 0 80 12" fill="none" xmlns="http://www.w3.org/2000/svg" width="80" height="12">
      <line x1="0" y1="6" x2="30" y2="6" stroke="#d5d5d5" strokeWidth="1.5" strokeDasharray="3 2"/>
      <g transform="translate(30, 0)">
        <path d="M11.0493 6.63604C11.0376 6.41458 10.956 6.22809 10.8045 6.07657C10.653 5.92505 10.4665 5.84346 10.245 5.8318L7.34278 5.8318L4.70278 1.6183H3.65378L4.98252 5.84928L2.06279 5.8318L1.27603 4.80028L0.489279 4.7828L1.01378 6.63604L0.48928 8.48928L1.29352 8.48928L2.08027 7.42279L4.96503 7.40531L3.65378 11.6538L4.70278 11.6538L7.34278 7.44027L10.245 7.44027C10.4548 7.44027 10.6413 7.35869 10.8045 7.19551C10.9677 7.03233 11.0493 6.84584 11.0493 6.63604Z" fill="#436067"/>
      </g>
      <line x1="42" y1="6" x2="80" y2="6" stroke="#d5d5d5" strokeWidth="1.5" strokeDasharray="3 2"/>
    </svg>
    :
    <img
      className="light-card_divider-icon"
      src="/iceholidays-assets/images/v3/flight-solid-icon.svg"
      alt=""
      aria-hidden="true"
    />
    }
  </div>
);

const FlightScheduleV3 = (props: {
  flights: any[];
  guaranteedDeparture?: boolean;
  arrowLeft?: number;
  isMobile?: boolean
}) => {
  const { flights, guaranteedDeparture, arrowLeft = 65 , isMobile} = props;

  if (!flights?.length) return null;

  return (
    <div className="flights" style={{ "--arrow-left": `${arrowLeft}px` } as React.CSSProperties}>
      <div className="flights_header">
        <span className="section-sublabel">Scheduled Flights</span>
        {guaranteedDeparture && <GuaranteedDepartureBadge />}
      </div>
      {/* Native CSS scroll-snap row — no react-slick (avoids fractional-slidesToShow ghost-scroll) */}
      <div className="flights_scroll">
        {flights.map((flight: any) => (
          <div key={flight.id} className="flight-card">
            <div className="flight-card_inner">
              <div className="flight-card_airline">
                <img src={flight.airline_logo} alt={flight.airline} onError={(e) => {
                  e.currentTarget.style.maxWidth = 'none';
                  e.currentTarget.style.width = 'auto';
                }} />
                <span className="flight-card_no">{flight.flight_no}</span>
              </div>
              <div className="flight-card_separator">
                <span className="flight-card_notch flight-card_notch--left" />
                <span className="flight-card_notch flight-card_notch--right" />
              </div>
              <div className="flight-card_route">
                <div className="flight-card_point">
                  <span className="flight-card_time">{flight.departure_time}</span>
                  <span className="flight-card_city">{flight.from_airport}</span>
                  <span className="flight-card_date">{flight.departure_date}</span>
                </div>
                <RouteDivider isMobile={isMobile} />
                <div className="flight-card_point flight-card_point--right">
                  <span className="flight-card_time">{flight.arrival_time}</span>
                  <span className="flight-card_city">{flight.to_airport}</span>
                  <span className="flight-card_date">{flight.arrival_date}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlightScheduleV3;
